import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let MarketRules = class MarketRules extends Vue {
    constructor() {
        super(...arguments);
        this.rulesTitle = '活动规则';
        this.isShowModal = false;
    }
    get content() {
        return this.data.content.value;
    }
    get url() {
        return this.data.cover.url;
    }
    triggleModal() {
        this.isShowModal = !this.isShowModal;
        if (this.isShowModal) {
            try {
                this.$el.parentElement.style.zIndex = '1000';
            }
            catch { }
        }
        else {
            try {
                this.$el.parentElement.style.zIndex = '994';
            }
            catch { }
        }
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], MarketRules.prototype, "data", void 0);
MarketRules = tslib_1.__decorate([
    Component({
        inheritAttrs: false,
    })
], MarketRules);
export default MarketRules;
